<template>
  <div>
    <div class="grid grid-cols-1 mb-lg">
      <BarProgressStepper
          current-step="4"
          total-steps="12"
          start-label="Start"
          end-label="Complete"
      />
    </div>
    <div class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      <div class="flex flex-col">
        <div>
          <SidebarWidget>
            <template v-slot:title>What’s a Bulk Send?</template>
            <template v-slot:content>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sit amet massa aliquam, suscipit lectus
                consequat, molestie justo. Ut congue lorem ut libero mollis porttitor. </p>
            </template>
            <template v-slot:cta>
              <BaseButton
                class="w-full"
                variant="secondary"
                size="large"
              >
                Click me
              </BaseButton>
            </template>
          </SidebarWidget>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarWidget from '@/components/library/widgets/SidebarWidget.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import BarProgressStepper from '@/components/library/progressSteppers/BarProgressStepper/BarProgressStepper.vue';

export default {
  name: 'BulkSendComponents',
  components: { BarProgressStepper, BaseButton, SidebarWidget },
};
</script>

<style scoped>

</style>
